import React from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { checkIsActive, KTSVG } from '../../../helpers'
import { useLayout } from '../../core'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  comingSoon?: boolean
  children? : React.ReactNode
}

const AsideMenuItem: React.FC<Props> = ({
  children ,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  comingSoon = false,
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)
  const { config } = useLayout()
  const { aside } = config

  return (
    <div className='menu-item'>
      <Link
        className={clsx(`menu-link without-sub ${title.toLowerCase().includes('manage account') && 'manage_account'}`, { active: isActive })}
        to={to}
        style={{ position: 'relative' }}
        title={comingSoon ? `${title} (Coming Soon)` : title}
      >
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {/* {icon && aside.menuIcon === 'svg' && ( */}
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        {/* )} */}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className='menu-title'>{title}</span>
        {comingSoon && (
          // Absolute overlay so the badge never widens the menu row.
          // Native `title` attr on the Link provides the full "Coming Soon"
          // text on hover.
          <span
            style={{
              position: 'absolute',
              right: '6px',
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundColor: '#FEF3C7',
              color: '#92400E',
              fontSize: '8px',
              padding: '1px 4px',
              borderRadius: '3px',
              lineHeight: 1,
              textTransform: 'uppercase',
              letterSpacing: '0.3px',
              fontWeight: 600,
              pointerEvents: 'none',
            }}
          >
            Soon
          </span>
        )}
      </Link>
      {children}
    </div>
  )
}

export { AsideMenuItem }